module.exports = __webpack_public_path__ + "img/2695-5.28bd5405.png";